export enum EnumProjectType {
    FrenchFries = 'FRENCH_FRIES',
    Car = 'CAR',
    OneMoreValue = 'ONE_MORE_VALUE'
}